
define('modules/application/wizard/classes/automationSimpleSystemSelection',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./genericElement"

  ],

  function(app, Backbone, genericElement) {
    /**
     * This is the main module object, it contains the main views (titlebar & content) and the main model
     */
    var automationSimpleSystemSelection = _.extend({}, genericElement, {

      Views: {

        /**
         * This view manage the title bar of this section
         */
        titleBar: genericElement.Views.titleBar.extend({
          template: "application/wizard/sections/automationSimpleSystemSelection/titleBar",
          tagName: "h3",
          initialize: function() {
            genericElement.Views.titleBar.prototype.initialize.apply(this);
            this.model.bind('change', this.setLabel, this);
            this.model.bind('packages:fetching', this.setLoadingLabel, this);
            this.model.bind('packages:fetched', this.setLabel, this);
            this.model.bind('render:requested', this.setLabel, this);
          },

          setLabel: function() {
            var caption = this.$el.find(".caption");
            var automationSystem = this.model.get("automationSystem"),
                traditional = this.model.get("traditional");

            automationSystem = automationSystem.lightsAndRollingShutters.enabled;
            traditional = traditional.enabled;

            var captionVisibility = automationSystem /*|| energyManagement*/ || traditional;
            captionVisibility = captionVisibility ? "" : "hidden";

            var labelContent = automationSystem ? $.i18n._("IDS_WAM8_17_1") + " - " : "";

            labelContent += traditional ? $.i18n._("IDS_WAM8_17_3") : "";

            labelContent = String(labelContent);
            if (labelContent.endsWith(" - "))
              labelContent = labelContent.substring(0, labelContent.length - 3);

            if ((labelContent) && (labelContent !== "")) {
              if (caption.is(".hidden"))
                caption.hide(0, function() {
                  $(this).removeClass("hidden");
                  caption.html(labelContent);
                  caption.fadeIn(200);
                });
              else
                caption.html(labelContent);
            } else {
              if (!caption.is(".hidden")) {
                caption.fadeOut(200, function() {
                  $(this).addClass("hidden");
                });
              }
            }
          },

          setLoadingLabel: function() {
            var caption = this.$el.find(".caption"),
              labelContent = $.i18n._("IDS_W4_9010");

            if (caption.is(".hidden"))
              caption.hide(0, function() {
                $(this).removeClass("hidden");
                caption.html(labelContent);
                caption.fadeIn(200);
              });
            else
              caption.html(labelContent);
          },

          afterRender: function() {
            this.setLabel();
          }
        }),

        /**
         * This view manage the content of this section
         */
        content: genericElement.Views.content.extend({

          template: "application/wizard/sections/automationSimpleSystemSelection/content",
          serialize: function() {
            return {
              model: this.model,
              app: app,
              automationSystemNaturalHideDone: false//this.automationSystemNaturalHideDone//,
              //energySystemNaturalHideDone: this.energySystemNaturalHideDone
            };
          },

          events: {
            "click .checkbox": "updateValues",
            "click .quantity-box .ui-spinner-down": "quantityBoxDecrementButtonClicked",
            "click .quantity-box .ui-spinner-up": "quantityBoxIncrementButtonClicked",
            "click .toggleInfoButton": "toggleInfos"//,
            //"click .toggleEnergyInfoButton": "toggleEnergyInfos"
          },

          initialize: function() {
            genericElement.Views.content.prototype.initialize.apply(this);

            if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") && BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") !== 0)
              this.model.fetchPackages();
            else
              window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.accessoryLineChosenEventHandler, this);

            //window.BticinoS4B.eventAggregator.bind("accessoryLine:confirmed", this.lockSystemTypeSelection, this);

            this.model.bind("render:requested", this.render, this);

            this.model.unbind("packages:fetched", this.packagesFetchedEventHandler);
            this.model.bind("packages:fetched", this.packagesFetchedEventHandler, this);
            this.automationSystemModelChangedEventHandler();
          },

          automationSystemModelChangedEventHandler: function() {
            this.automationSystemNaturalHideDone = true;
          },
/*
          energyManagementSystemModelChangedEventHandler: function() {
            this.energySystemNaturalHideDone = true;
          },
*/
          toggleInfos: function(e) {
            var that = this;
            e.preventDefault();

            if (window.isBrowserCompatibleWithAnimation())
              that.$el.find(".toggleInfoButton .arrow-info").transition({
                rotate: "+=180"
              });
            else {
              if (this.$el.find(".tooltip:visible").length > 0)
                that.$el.find(".toggleInfoButton .arrow-info").attr("src", "/assets/img/info-arrow-down.png");
              else
                that.$el.find(".toggleInfoButton .arrow-info").attr("src", "/assets/img/info-arrow-up.png");
            }

            if (this.$el.find(".tooltip:visible").length === 0)
              that.$el.find("hr").toggle();

            this.$el.find(".tooltip").slideToggle(function() {
              if (that.$el.find(".tooltip:visible").length === 0) that.$el.find("hr").toggle();
            });
            return false;
          },
/*
          toggleEnergyInfos: function(e) {
            var that = this;
            e.preventDefault();

            if (window.isBrowserCompatibleWithAnimation())
              that.$el.find(".toggleEnergyInfoButton .arrow-info").transition({
                rotate: "+=180"
              });
            else {
              if (this.$el.find(".energyTooltip:visible").length > 0)
                that.$el.find(".toggleEnergyInfoButton .arrow-info").attr("src", "/assets/img/info-arrow-down.png");
              else
                that.$el.find(".toggleEnergyInfoButton .arrow-info").attr("src", "/assets/img/info-arrow-up.png");
            }

            if (this.$el.find(".energyTooltip:visible").length === 0)
              that.$el.find("hr").toggle();

            this.$el.find(".energyTooltip").slideToggle(function() {
              if (that.$el.find(".energyTooltip:visible").length === 0) that.$el.find("hr").toggle();
            });
            return false;
          },
*/
          quantityBoxDecrementButtonClicked: function() {
            this.model.decrementZigbeeRadioInterfaceValue();
          },

          quantityBoxIncrementButtonClicked: function() {
            this.model.incrementZigbeeRadioInterfaceValue();
          },

          updateValues: function(e) {

            if ($(e.currentTarget).parents(".automation").length > 0)
              this.automationSystemModelChangedEventHandler();
            //else if ($(e.currentTarget).parents(".energy-management").length > 0)
            //  this.energyManagementSystemModelChangedEventHandler();
            
            var checkboxClicked = e.target.nextSibling.name;
            var dinQuantity = 0;

            //Retrieve values from the view
            var lightsAndRollingShuttersEnabled = true;//this.$el.find("input[name='lightsAndRollingShutters']").is(":checked");
            var memoryModuleEnabled = this.$el.find("input[name='memoryModule']").is(":checked");
            var zigbeeRadioEnabled = this.$el.find("input[name='zigbeeRadio']").is(":checked");
            //var traditionalEnabled = false;//this.$el.find("input[name='traditional']").is(":checked");

            BticinoS4B.solution.automationSimple.inserted = true;//(memoryModuleEnabled || zigbeeRadioEnabled);

            if (!lightsAndRollingShuttersEnabled)
              memoryModuleEnabled = false;

            if (!lightsAndRollingShuttersEnabled)
              zigbeeRadioEnabled = false;

            //Clone the current model
            var automationSystem = _.extend({}, jQuery.extend(true, {}, this.model.get("automationSystem")));
            var traditional = _.extend({}, jQuery.extend(true, {}, this.model.get("traditional")));

            var lightPointsPresent = BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsLength") !== 0 : false,
              enginesPresent = BticinoS4B.Instances.Models.ApplicationModel.get("enginesLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("enginesLength") !== 0 : false,
              zigbeeRadioPresent = BticinoS4B.Instances.Models.ApplicationModel.get("zigbeeRadioLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("zigbeeRadioLength") !== 0 : false,
              controlledLoadsPresent = BticinoS4B.Instances.Models.ApplicationModel.get("controlledLoadsLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("controlledLoadsLength") !== 0 : false,
              gaugesAndInterfacesPresent = BticinoS4B.Instances.Models.ApplicationModel.get("gaugesAndInterfacesLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("gaugesAndInterfacesLength") !== 0 : false,
              traditionalsPresent = BticinoS4B.Instances.Models.ApplicationModel.get("traditionalsLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("traditionalsLength") !== 0 : false;


            switch (checkboxClicked) {
              case "memoryModule":
                dinQuantity = (automationSystem.zigbeeRadio.enabled ? automationSystem.zigbeeRadio.zigbeeInterface.value : 0) +
                  (BticinoS4B.Instances.Models.ApplicationModel.get("scenarioDinModuleQuantity") ? BticinoS4B.Instances.Models.ApplicationModel.get("scenarioDinModuleQuantity") : 0);
                if (dinQuantity + 1 > 9) {
                  memoryModuleEnabled = false;
                }
                break;
              case "zigbeeRadio":
                if (zigbeeRadioEnabled) {
                  dinQuantity = (memoryModuleEnabled ? 1 : 0) +
                    (BticinoS4B.Instances.Models.ApplicationModel.get("scenarioDinModuleQuantity") ? BticinoS4B.Instances.Models.ApplicationModel.get("scenarioDinModuleQuantity") : 0);
                  if (dinQuantity + 1 > 9)
                    zigbeeRadioEnabled = false;
                  else {
                    automationSystem.zigbeeRadio.zigbeeInterface.value = 1;
                    BticinoS4B.Instances.Models.ApplicationModel.set("zigbeeInterfaceQuantity", automationSystem.zigbeeRadio.zigbeeInterface.value);
                  }
                } else {
                  automationSystem.zigbeeRadio.zigbeeInterface.value = 0;
                  BticinoS4B.Instances.Models.ApplicationModel.set("zigbeeInterfaceQuantity", automationSystem.zigbeeRadio.zigbeeInterface.value);
                }
                break;
            }

            //Valorize cloned model and request confirms
            if (!lightPointsPresent && !enginesPresent) {
              automationSystem.lightsAndRollingShutters.enabled = lightsAndRollingShuttersEnabled;
            } else {
              if (!lightsAndRollingShuttersEnabled && confirm("All the packages will be removed. Are you sure to continue?"))
                automationSystem.lightsAndRollingShutters.enabled = lightsAndRollingShuttersEnabled;
            }

            if (zigbeeRadioPresent) {
              automationSystem.zigbeeRadio.enabled = zigbeeRadioEnabled;
            } else {
              if (!zigbeeRadioEnabled && BticinoS4B.Instances.Models.ApplicationModel.get("zigbeeCommandsQuantity") && BticinoS4B.Instances.Models.ApplicationModel.get("zigbeeCommandsQuantity") > 0) {
                if (confirm("All the packages will be removed. Are you sure to continue?"))
                  automationSystem.zigbeeRadio.enabled = zigbeeRadioEnabled;
              } else
                automationSystem.zigbeeRadio.enabled = zigbeeRadioEnabled;
            }

            automationSystem.lightsAndRollingShutters.memoryModule.value = memoryModuleEnabled;

            BticinoS4B.Instances.Models.ApplicationModel.set("zigbeeStatus", automationSystem.zigbeeRadio.enabled);

            //Save cloned model
            this.model.set({
              automationSystem: automationSystem,
              traditional: traditional
            });

            //Render the view with new values
            this.render();
          },

          packagesFetchedEventHandler: function() {
            this.$el.find(".loadingSection").hide();
            this.$el.find(".regularSection").show();
            this.render();
          },

          showLoader: function() {
            this.$el.find(".regularSection").hide();
            this.$el.find(".noAccessoryLineSection").hide();
            this.$el.find(".loadingSection").show();
          },

          //Event handlers
          accessoryLineChosenEventHandler: function(accessoryLineId) {
            this.showLoader();
            this.model.fetchPackages();
          },

          systemSelectionChangedEventHandler: function() {
            if (!this.model.get("inhibited"))
              this.updateSystemSelection();
          },

          lockSystemTypeSelection: function() {
            this.model.set("inhibited", true);
            this.$el.find("input[rel='alreadyStyled']").removeAttr("rel").attr("disabled", "disabled");
            this.$el.find(".checkbox").remove();
            window.customizeFormElements.call();
          },

          afterRender: function() {
            this.$el.find("input[rel='alreadyStyled']").removeAttr("rel");
            this.$el.find(".checkbox").remove();
            window.customizeFormElements.call();

          }

        })
      },

      /**
       * The main model for this section, it store infos about the plant type and a reference to the model that
       * manage the power supply section
       */
      Model: genericElement.Model.extend({

        defaults: {
          inhibited: false,
          automationSystem: {
            lightsAndRollingShutters: {
              enabled: true,
              memoryModule: {
                value: false
              }
            },
            zigbeeRadio: {
              enabled: false,
              zigbeeInterface: {
                value: 0
              }
            }
          },
          traditional: {
            enabled: false,
            regulatoryLevel: {
              levels: [{
                value: 1,
                name: "Level 1"
              }, {
                value: 2,
                name: "Level 2"
              }]
            }
          }
        },

        initialize: function() {
          window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          window.BticinoS4B.eventAggregator.unbind("automationSystemSelection:addedFromKit", this.productAddedFromKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("automationSystemSelection:addedFromKit", this.productAddedFromKitEventHandler, this);

          window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen", this.accessoryLineEventHandler);
          window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.accessoryLineEventHandler, this);

          this.updateSystemSelectionGlobally();
          this.bind("change", this.updateSystemSelectionGlobally, this);
          
        },

        accessoryLineEventHandler: function(){
          this.trigger("change");
          window.BticinoS4B.eventAggregator.trigger('systems:changed');
          window.BticinoS4B.solution.automationSimple.inserted = true;
        },

        decrementZigbeeRadioInterfaceValue: function() {
          var automationSystem = this.get("automationSystem"),
            zigbeeRadio = automationSystem.zigbeeRadio;

          if (zigbeeRadio.enabled) {
            if ((zigbeeRadio.zigbeeInterface.value - 1) > 0) {
              zigbeeRadio.zigbeeInterface.value--;
              this.set("automationSystem", automationSystem);
              BticinoS4B.Instances.Models.ApplicationModel.set("zigbeeInterfaceQuantity", zigbeeRadio.zigbeeInterface.value);
              this.trigger("render:requested");
            }
          }
        },

        incrementZigbeeRadioInterfaceValue: function() {
          var automationSystem = this.get("automationSystem"),
            zigbeeRadio = automationSystem.zigbeeRadio,
            memoryModuleValue = this.get("automationSystem").lightsAndRollingShutters.memoryModule.value ? this.get("automationSystem").lightsAndRollingShutters.memoryModule.value : 0,
            scenarioDinModuleQuantity = BticinoS4B.Instances.Models.ApplicationModel.get("scenarioDinModuleQuantity");

          if (zigbeeRadio.enabled) {
            if ((zigbeeRadio.zigbeeInterface.value + 1) <= 2) {
              zigbeeRadio.zigbeeInterface.value++;
              this.set("automationSystem", automationSystem);
              BticinoS4B.Instances.Models.ApplicationModel.set("zigbeeInterfaceQuantity", zigbeeRadio.zigbeeInterface.value);
              this.trigger("render:requested");
            }
          }
        },

        productAddedFromKitEventHandler: function(addedProduct) {
          var automationSystem = this.get("automationSystem");

          this.set("partOfKit", true);
          this.set("kitValue", 1);
          this.set("id", addedProduct.packageClassId);
          
          automationSystem.lightsAndRollingShutters.enabled = true;
          this.set("automationSystem", automationSystem);
 
          this.updateSystemSelectionGlobally();
          //this.trigger("render:requested");
        },

        updateSystemSelectionGlobally: function() {
          var choosenSystems = [];

          if (this.get("automationSystem").lightsAndRollingShutters.enabled)
            choosenSystems.push("lightsAndRollingShutters");
          if (this.get("automationSystem").zigbeeRadio.enabled) {
            choosenSystems.push("zigbeeRadio");
            BticinoS4B.Instances.Models.ApplicationModel.set("zigbeeStatus", true);
          }
          if (this.get("traditional").enabled)
            choosenSystems.push("traditional");

          BticinoS4B.Instances.Models.ApplicationModel.set("choosenSystems", choosenSystems);
          BticinoS4B.Instances.Models.ApplicationModel.set("memoryModuleQuantity", this.get("automationSystem").lightsAndRollingShutters.memoryModule.value ? 1 : 0);
          window.BticinoS4B.eventAggregator.trigger('systems:changed');
          this.trigger("render:requested");
        },

        deliverModel: function() {
          BticinoS4B.solution.automationSimple.automationSystemSelection = this;
          BticinoS4B.Instances.Models.ApplicationModel.set("automationSystemSelection", this);

          var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i = 0;

          //Memory module
          if (this.get("automationSystem").lightsAndRollingShutters.memoryModule.value)
            dataProvider.addItems("externalItems", {
              productCode: this.get("automationSystem").lightsAndRollingShutters.memoryModule.productCode,
              productLabel: this.get("automationSystem").lightsAndRollingShutters.memoryModule.productLabel,
              packageClassLabel: this.get("automationSystem").lightsAndRollingShutters.memoryModule.packageClassLabel,
              packageClassId: this.get("automationSystem").lightsAndRollingShutters.memoryModule.packageClassId,
              kitValue: this.get("automationSystem").lightsAndRollingShutters.memoryModule.kitValue,
              partOfKit: this.get("automationSystem").lightsAndRollingShutters.memoryModule.partOfKit,
              groupId: this.get("automationSystem").lightsAndRollingShutters.memoryModule.specialVars ? this.get("automationSystem").lightsAndRollingShutters.memoryModule.specialVars.groupId : "",
              decade0: 1,
              quantity: 1,
              price: this.get("automationSystem").lightsAndRollingShutters.memoryModule.price
            });

          if (this.get("automationSystem").lightsAndRollingShutters.memoryModule.secondaryProducts) {
            for (i = 0; i < this.get("automationSystem").lightsAndRollingShutters.memoryModule.secondaryProducts.length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: this.get("automationSystem").lightsAndRollingShutters.memoryModule.secondaryProducts[i].productCode,
                productLabel: this.get("automationSystem").lightsAndRollingShutters.memoryModule.secondaryProducts[i].productLabel,
                packageClassLabel: this.get("automationSystem").lightsAndRollingShutters.memoryModule.secondaryProducts[i].packageClassLabel,
                packageClassId: this.get("automationSystem").lightsAndRollingShutters.memoryModule.secondaryProducts[i].packageClassId,
                kitValue: this.get("automationSystem").lightsAndRollingShutters.memoryModule.kitValue,
                partOfKit: this.get("automationSystem").lightsAndRollingShutters.memoryModule.partOfKit,
                decade0: 1,
                quantity: 1,
                price: this.get("automationSystem").lightsAndRollingShutters.memoryModule.secondaryProducts[i].price
              });
            }
          }

          //ZigbeeRadio interfaces
          if (this.get("automationSystem").zigbeeRadio.enabled)
            dataProvider.addItems("externalItems", {
              productCode: this.get("automationSystem").zigbeeRadio.zigbeeInterface.productCode,
              productLabel: this.get("automationSystem").zigbeeRadio.zigbeeInterface.productLabel,
              packageClassLabel: this.get("automationSystem").zigbeeRadio.zigbeeInterface.packageClassLabel,
              packageClassId: this.get("automationSystem").zigbeeRadio.zigbeeInterface.packageClassId,
              kitValue: this.get("automationSystem").zigbeeRadio.zigbeeInterface.kitValue,
              partOfKit: this.get("automationSystem").zigbeeRadio.zigbeeInterface.partOfKit,
              groupId: this.get("automationSystem").zigbeeRadio.zigbeeInterface.specialVars ? this.get("automationSystem").zigbeeRadio.zigbeeInterface.specialVars.groupId : "",
              decade0: 1,
              quantity: this.get("automationSystem").zigbeeRadio.zigbeeInterface.value,
              price: this.get("automationSystem").zigbeeRadio.zigbeeInterface.price
            });

          if (this.get("automationSystem").zigbeeRadio.zigbeeInterface.secondaryProducts) {
            for (i = 0; i < this.get("automationSystem").zigbeeRadio.zigbeeInterface.secondaryProducts.length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: this.get("automationSystem").zigbeeRadio.zigbeeInterface.secondaryProducts[i].productCode,
                productLabel: this.get("automationSystem").zigbeeRadio.zigbeeInterface.secondaryProducts[i].productLabel,
                packageClassLabel: this.get("automationSystem").zigbeeRadio.zigbeeInterface.secondaryProducts[i].packageClassLabel,
                packageClassId: this.get("automationSystem").zigbeeRadio.zigbeeInterface.secondaryProducts[i].packageClassId,
                kitValue: this.get("automationSystem").zigbeeRadio.zigbeeInterface.kitValue,
                partOfKit: this.get("automationSystem").zigbeeRadio.zigbeeInterface.partOfKit,
                decade0: 1,
                quantity: this.get("automationSystem").zigbeeRadio.zigbeeInterface.value,
                price: this.get("automationSystem").zigbeeRadio.zigbeeInterface.secondaryProducts[i].price
              });
            }
          }
        },

        fetchPackages: function() {
          this.trigger("packages:fetching");
          var that = this,
            //Defining race conditions variables
            memoryModuleDataFetchCompleted = false,
            zigbeeRadioInterface = false;

          //Race condition check
          var checkRaceCondition = function() {
            if (memoryModuleDataFetchCompleted) {
              that.trigger("packages:fetched");
            }
          };

          //Data products retrieval
          var retrieveProductData = function(data, objectToValorize, confirmCondition) {
            var packageToAssign = data.packages[0];

            if (packageToAssign.specialVars && packageToAssign.specialVars !== "" && typeof(packageToAssign.specialVars) !== "object")
              packageToAssign.specialVars = JSON.parse(packageToAssign.specialVars);

            _.extend(objectToValorize, packageToAssign);

            BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageToAssign.packageClassId, function(data) {
              var mainProduct = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              })[0];
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });

              _.extend(objectToValorize, mainProduct);
              objectToValorize.secondaryProducts = secondaryProducts;

              confirmCondition();
              checkRaceCondition();
            }, true);

          };

          //Defining success callbacks
          var memoryModulePackageFetchSuccessCallback = function(data) {
            retrieveProductData(data, that.get("automationSystem").lightsAndRollingShutters.memoryModule, function() {
              memoryModuleDataFetchCompleted = true;
            });
          };
          var zigbeeRadioInterfacePackageFetchSuccessCallback = function(data) {
            retrieveProductData(data, that.get("automationSystem").zigbeeRadio.zigbeeInterface, function() {
              zigbeeRadioInterfaceDataFetchCompleted = true;
            });
          };
          
          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(800, memoryModulePackageFetchSuccessCallback, undefined, true);
          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(808, zigbeeRadioInterfacePackageFetchSuccessCallback, undefined, true);
        },

        loadProject: function(project) {
          var that = this,
            model,
            load = function() {
              that.set($.extend(true, that.attributes, model));
              that.updateSystemSelectionGlobally();
            };

          if (project.automationSystemSelection)
            model = project.automationSystemSelection;

          if (!this.get("fetchedPackages"))
            this.bind("packages:fetched", load);
          
          load();

        }

      })
    });

    // Required, return the module for AMD compliance
    return automationSimpleSystemSelection;
  });